import React, { useEffect, useRef, useState } from 'react'
import downloadIcon from "../../../assets/card-icons/download-black.svg"
import eyeIcon from "../../../assets/eye-icon.svg"
import CustomDocViewer from '../../../components/CustomDocViewer/CustomDocViewer'
import CustomPagination from '../../../components/CustomPagination/CustomPagination'
import usePagination from '../../../hooks/usePagination'
import { getDetails } from '../../../services/http/http.service'
import { setPageData } from '../../../store/pageData/pageData.slice'
import { useAppDispatch, useAppSelector } from '../../../store/storeRequests'
import APIList from '../../../utils/constants/APIList'
import StoreSelectors from '../../../utils/constants/StoreSelectors.constants'
import formatDate from '../../../utils/constants/formatDate'
import { APIResponseCodes } from '../../../utils/constants/keys.constants'
import openURL from '../../../utils/helpers/openURL'
import '../profile-page.css'

const Invoices: React.FunctionComponent = () => {

    const dispatch = useAppDispatch()
    const isUIMounted = useRef(false)

    const { pageData } = useAppSelector(StoreSelectors.PAGE_STATE)

    const [totalPages, setTotalPages] = useState(1)
    const [fileToView, setFileToView] = useState('')

    const { currentItems, handlePageClick, itemsPerPage, pageNumber } = usePagination({
        items: typeof pageData?.resApiList === 'undefined' ? [] : pageData?.resApiList,
        from: 'invoice',
        perPageResults: 10
    })

    /** Get all invoices */
    const getInvoices = async () => {
        const response = await getDetails(APIList.GET_INVOICES + `?page_no=1`, getInvoices)

        if (response.statusCode === APIResponseCodes.SUCCESS) {
            dispatch(setPageData(response.data))
            setTotalPages(response.data?.total_pages)
        }
    }

    useEffect(() => {
        if (isUIMounted.current) return
        isUIMounted.current = true
        getInvoices()
    }, [])


    return (
        <>
            {
                currentItems.map((data, index) => (
                    <div key={index} className="profile-invoices">
                        <div className="mf-listing-card-container bg-white">
                            <div className="d-flex mf-common-card p-3">
                                <div className="">
                                    <p className="mb-0 text-primary-color font-16 weight-500">
                                        Invoice <strong className='text-primary-color weight-500'>{`#${data.bill_number}`}</strong>
                                    </p>
                                    <p className="mb-0 font-16 weight-400 mf-listing-api-desc mt-1">Generated at {formatDate(data.created_at, 'fullmonth')}</p>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex checkout-card-actions card-status-right pe-0">
                                    <button onClick={() => setFileToView(data.bill)} className="download-btn border-0 bg-white me-2 me-md-3 me-lg-3">
                                        <img width={15} height={15} src={eyeIcon} alt="view" />
                                    </button>

                                    <button onClick={() => openURL(data.bill, 'download', `${data.bill_number}.pdf`)} className="download-btn border-0 bg-white me-2 me-md-4 me-lg-4">
                                        <img
                                            width={15}
                                            height={15}
                                            src={downloadIcon}
                                            alt="download"
                                        />
                                    </button>

                                    {
                                        data.paid &&
                                        <button type="button" className="card-status-btn text-capitalize card-status-btn-processed font-14 weight-600 me-3">
                                            paid
                                        </button>
                                    }
                                    {
                                        new Date(data.due_date).getMilliseconds() < Date.now() && !data.paid &&
                                        <button
                                            type="button"
                                            className="card-status-btn card-status-btn-pending text-capitalize font-14 weight-600 me-3"
                                        >
                                            due
                                        </button>
                                    }
                                    {
                                        new Date(data.due_date).getMilliseconds() > Date.now() && !data.paid &&
                                        <button type="button" className="card-status-btn card-status-btn-failed text-capitalize font-14 weight-600 me-3" >
                                            overdue
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }

            {
                totalPages > 1 &&
                <CustomPagination itemsPerPage={itemsPerPage} handlePageClick={handlePageClick} pageCount={pageData?.total_pages} pageNumber={pageNumber - 1} />
            }
            {
                fileToView.length !== 0 &&
                <CustomDocViewer url={fileToView} uploadedFile={null} onClose={() => setFileToView('')} />
            }

            {
                currentItems.length === 0 &&
                <div className="mf-listing-card-container bg-white px-3 py-4">
                    <p className="mb-0 font-13 text-center weight-500 text-primary-color">No invoices available to display...</p>
                </div>
            }
        </>
    )

}

export default Invoices